import React, { useState } from 'react';
import Helmet from 'react-helmet';
import { Inertia } from '@inertiajs/inertia';
import { usePage } from '@inertiajs/inertia-react';
import TextInput from '../../Shared/TextInput';
import LoadingButton from '../../Shared/LoadingButton';
import { toFormData } from '../../utils';
import axios from 'axios';
import Modal from './Modal';

const ProfileShowCard = () => {
     const { auth, app, errors, data } = usePage().props;
     const [sending, setSending] = useState(false);
     const [showModal, setShowModal] = useState(false);
     const [values, setValues] = useState({
          id: data.product.id || null,
          quantity: data.product.quantity || 1,
          email: app.cart.email,
          _email:'',
          message: '',
     });

     const handleModal = () => setShowModal(!showModal);

     function handleChange(e) {
          const key = e.target.name;
          const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
          let message = '';
          if(value > data.product.maxSell){
               setSending(true);
               message = `Vous ne pouvez en acheter plus de ${data.product.maxSell}`;
          }else{
               setSending(false);
               message = '';
          }
          setValues(values => ({
               ...values,
               [key]: value,
               message: message
          }));
     }

     function handleSubmit(e) {
          e.preventDefault();
          setSending(true);
          Inertia.post(route('site.cart.add'), values).then(() => {
               // setSending(false);
          });

     }
     return (
          <React.Fragment key="c-show-product">
               <form onSubmit={handleSubmit}>
                    <div className="grid grid-cols-1 md:grid-cols-2">
                         <div className="h-full">
                              {data.product.gallery && (
                                   <div className="flex justify-center w-full pb-4 bg-gray-100 align-items-center">
                                        <a onClick={handleModal} className="px-2 mt-4 text-yellow-800 bg-yellow-500 rounded hover:text-white hover:bg-yellow-600 hover:cursor-pointer">Aperçu</a>
                                        {showModal ? <Modal title={'Book Preview'} handleModal={handleModal} content={data.product.gallery} /> : null}
                                   </div>
                              )}
                              {!data.product.image && (<img src={`https://ui-avatars.com/api/?name=${data.product.name}&amp;color=1DAD2C&amp;background=BDD9C0`} className="object-cover object-top w-full" alt={data.product.name} />)}
                              {data.product.image && (<img src={`${data.product.image}`} className="object-cover object-top w-full" alt={data.product.name} />)}
                         </div>
                         <div className="flex p-8 bg-gray-100">
                              <div className="max-w-lg">
                                   <h1 className="text-2xl uppercase">{data.product.name}</h1>
                                   <p className="font-medium text-gray-600">{data.product.code}</p>
                                   <p className="p-1 mb-5 text-xs text-yellow-500 bg-yellow-100 rounded">
                                        {data.product.type && (<span>{data.product.type}</span>)}
                                        {data.product.category && (<span>{data.product.category.join(', ')}</span>)}
                                   </p>
                                   <p className="text-gray-600" dangerouslySetInnerHTML={{__html: data.product.description}}></p>
                                   {data.product.package && (
                                        <p className="block w-full mt-2">
                                             <label className="block text-xs font-small text-emerald-500" htmlFor="name">Ce paquet contient :</label>
                                             <ul className="pl-8 list-none">
                                                  {data.product.package.map(({name, type, qty, image}, i) => {
                                                       return <li className={`p-2 mt-2 rounded hover:shadow-md`} key={`s-${i}`}>
                                                            <div className="flex flex-inline">
                                                                 {!image && (<img src={`https://ui-avatars.com/api/?name=${name}&amp;color=7F9CF5&amp;background=EBF4FF`} className="w-10" />)}
                                                                 {image && (<img src={image} alt={name} className="flex w-10" />)}
                                                                 <div className="ml-3">
                                                                      <div className="w-full text-sm text-gray-700">{name} <span className="w-full text-xs text-gray-500">{type}</span></div>
                                                                      <div className="w-full text-sm text-gray-700">Quantity : {qty}</div>
                                                                 </div>
                                                            </div>
                                                       </li>
                                                  })}
                                             </ul>
                                        </p>
                                   )}
                                   {data.product.addCart && (<p className="mt-4">
                                        <span className={`${data.product.promotion?'text-md font-semibold text-gray-500 line-through':'text-lg font-semibold text-emerald-700'}`}>{data.product.currency} {data.product.price.toFixed(2)}</span>
                                        {(data.product.promotion > 0) && (<p><span className="text-lg font-semibold text-emerald-700">{data.product.currency} {data.product.promotion.toFixed(2)}</span></p>)}
                                   </p>)}
                                   {data.product.addCart && (<div className="flex">
                                        <TextInput
                                              className="block w-1/4 mt-4 border-none form-input bg-none"
                                              label={data.product.caption.quantity}
                                              name="quantity"
                                              type="number"
                                              disable={false}
                                              readonly={false}
                                              errors={errors.quantity}
                                              value={values.quantity}
                                              onChange={handleChange}
                                         />
                                        <div className="block w-1/2 pt-5 mt-4 border-none bg-none">
                                             <LoadingButton type="submit" loading={sending} className="px-2 py-2 ml-3 text-xs font-semibold tracking-widest text-white uppercase transition duration-150 ease-in-out border border-transparent rounded md:px-3 md:py-3 bg-emerald-800 md:text-sm hover:bg-emerald-700 active:bg-emerald-900 focus:outline-none focus:border-emerald-900 focus:shadow-outline-gray disabled:opacity-25">
                                                  {data.product.caption.add_cart}
                                             </LoadingButton>
                                        </div>
                                   </div>)}
                                   {!data.product.addCart && (<p className="font-semibold text-yellow-600">{data.product.naonline}</p>)}
                                   {(values.message != '') && (<p className="flex italic text-red-600">
                                        {values.message}
                                   </p>)}
                              </div>
                         </div>
                    </div>
               </form>
          </React.Fragment>
     );
};

export default ProfileShowCard;